import { LayoutTemplate } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const website = defineDashboardModule({
  id: "website",
  nav: [
    {
      group: "Publishing",
      title: "Website",
      to: "/site",
      icon: LayoutTemplate,
    },
  ],
  routes: [
    {
      path: "/site",
      component: lazyPage(() => import("@/routes/site"), "SitePage"),
    },
  ],
})
